import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.693.282c.41.378.41.99 0 1.331L7.078 12.232c-.341.41-.952.41-1.33 0L.283 6.762c-.377-.342-.377-.954 0-1.332a.97.97 0 0 1 1.364 0l4.785 4.79 9.93-9.938c.378-.376.989-.376 1.33 0"
    }, null, -1)
  ]))]))
}
export default { render: render }